<template>
    <div
        :class="[
            'vendor-card flex flex-col items-center justify-center rounded-lg cursor-pointer transition-all',
            isSelected ? 'vendor-card-selected' : 'vendor-card-unselected'
        ]"
        @click="$emit('select', vendor.id)"
    >
        <div v-if="vendor.icon || vendor.iconComponent" class="flex items-center justify-center mb-4">
            <div
                v-if="vendor.iconBgClass"
                :class="[
                    'flex items-center justify-center rounded-lg p-3',
                    vendor.iconBgClass
                ]"
            >
                <ThemeImage
                    v-if="vendor.icon"
                    :icon="vendor.icon"
                    :alt="vendor.name"
                    class="msg91-icon"
                />
                <div
                    v-else-if="vendor.iconComponent"
                    class="flex items-center justify-center text-white"
                >
                    <component :is="vendor.iconComponent" class="msg91-icon" />
                </div>
            </div>
            <div v-else class="flex items-center justify-center">
                <ThemeImage
                    v-if="vendor.icon"
                    :icon="vendor.icon"
                    :alt="vendor.name"
                    class="msg91-icon"
                />
                <div
                    v-else-if="vendor.iconComponent"
                    class="flex items-center justify-center"
                >
                    <component :is="vendor.iconComponent" class="msg91-icon" />
                </div>
            </div>
        </div>
        <div v-if="vendor.icon || vendor.iconComponent" class="text-base font-medium text_color">{{ vendor.name }}</div>
        <div v-else class="flex items-center justify-center h-full">
            <span class="text-2xl font-bold text_color">{{ vendor.name }}</span>
        </div>
    </div>
</template>

<script setup>
import ThemeImage from "@/src/components/ThemeImage.vue";

defineProps({
    vendor: {
        type: Object,
        required: true,
    },
    isSelected: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['select']);
</script>

<style scoped>
.vendor-card {
    height: 200px;
    border-radius: 8px;
    padding: 12px;
}

.vendor-card-unselected {
    box-shadow: 0 0 10px 0 var(--white-opacity-8);
    border: 1px solid var(--white-opacity-8);
}

.vendor-card-unselected:hover {
    background: var(--white-opacity-2);
}

.vendor-card-selected {
    background: var(--white-opacity-8);
    box-shadow: 0 0 10px 0 var(--white-opacity-15);
    border: 2px solid var(--primary-color);
}

.msg91-icon {
    width: 156.289px;
    height: auto;
    background-blend-mode: multiply;
}
</style>

